import { render } from "./order_autocompliteItem.vue?vue&type=template&id=09c0b567"
import script from "./order_autocompliteItem.vue?vue&type=script&lang=js"
export * from "./order_autocompliteItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__